function PartsStatus() {
  return (
    <div className="w-[84px] h-[22px] flex items-center justify-center rounded-[11px] bg-wo_color5 font-OpenSansRegular font-[400] text-titleColor text-[10px]">
      PARTS
    </div>
  );
}

export default PartsStatus;
